import React from 'react';
import { StatusPill } from '../design-system/StatusPill';
import { InfoPill } from '../design-system/InfoPill';
import { Typography } from '../design-system/typography';
import { colors, spacing } from '../design-system/tokens';

export interface FinancialTableRow {
  id: string;
  label: string;
  value: string;
  isNegative?: boolean;
  actionComponent?: React.ReactNode;
  isSeparator?: boolean;
  isTotal?: boolean;
}

interface FinancialTableProps {
  rows: FinancialTableRow[];
  className?: string;
}

export const FinancialTable: React.FC<FinancialTableProps> = ({ 
  rows,
  className = '' 
}) => {
  return (
    <div className={className}>
      <table style={{ 
        width: '100%', 
        borderCollapse: 'separate',
        borderSpacing: '0'
      }}>
        <tbody>
          {rows.map((row, index) => {
            if (row.isSeparator) {
              return (
                <tr key={row.id}>
                  <td 
                    colSpan={3}
                    style={{
                      height: '1px',
                      padding: `${spacing.sm} 0`,
                      borderBottom: 'none'
                    }}
                  >
                    <div style={{ 
                      height: '1px',
                      backgroundImage: 'repeating-linear-gradient(to right, #D7DADB 0px, #D7DADB 4px, transparent 4px, transparent 8px)'
                    }} />
                  </td>
                </tr>
              );
            }

            return (
              <tr key={row.id}>
                {/* Label Column */}
                <td style={{ 
                  width: '220px',
                  padding: `${spacing.xs} 0`,
                  verticalAlign: 'middle'
                }}>
                  <Typography 
                    variant="ledgerLabel" 
                    as="div"
                    style={{ 
                      color: colors.text.primary,
                      textTransform: 'uppercase'
                    }}
                  >
                    {row.label}
                  </Typography>
                </td>

                {/* Value Column */}
                <td style={{ 
                  width: '100px',
                  padding: `${spacing.xs} 0`,
                  textAlign: 'right',
                  verticalAlign: 'middle'
                }}>
                  <Typography 
                    variant="ledgerNumbers" 
                    as="div"
                    style={{ 
                      color: row.isNegative ? colors.status.negative : colors.text.primary,
                      fontFamily: '"Reddit Mono", monospace',
                      whiteSpace: 'pre'
                    }}
                  >
                    {row.value}
                  </Typography>
                </td>

                {/* Action Column */}
                <td style={{ 
                  width: 'auto',
                  padding: `${spacing.xs} 0 ${spacing.xs} ${spacing.lg}`,
                  verticalAlign: 'middle'
                }}>
                  {row.actionComponent || null}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FinancialTable;